import React, { useEffect, useState } from 'react'
import BarGraph from './BarGraph'

const GroupedByUserGraph = ({
  data,
  xFieldLabel,
  groupedValKey,
  setShowDetailsOn = null,
  detailKey = null,
  stat = 'sum',
  yFieldLabel = 'minutes',
  tooltipFunc = null,
  user_identifier = 'user_id',
  groupingFunc = null,
  handleBarClick = null,
}) => {
  const [groupedData, setGroupedData] = useState([])
  if (!tooltipFunc) {
    tooltipFunc = (val) => (val < 1 ? '< 1m' : `${val} min`)
  }
  const formatTime = (ms) => {
    if (ms < 1000 && ms != 0) return `${ms} ms`
    const totalSeconds = Math.floor(ms / 1000)
    const hours = Math.floor(totalSeconds / 3600)
    const minutes = Math.floor((totalSeconds % 3600) / 60)
    const seconds = totalSeconds % 60

    const parts = []
    if (hours > 0) parts.push(`${hours} hr${hours !== 1 ? 's' : ''}`)
    if (minutes > 0) parts.push(`${minutes} min${minutes !== 1 ? 's' : ''}`)
    if (seconds > 0 || parts.length === 0)
      parts.push(`${seconds} sec${seconds !== 1 ? 's' : ''}`)

    return parts.join(' ')
  }

  useEffect(() => {
    const groupedData = []
    if (data && data.length !== 0) {
      data.forEach((record) => {
        let groupKey, value
        if (groupingFunc) {
          const result = groupingFunc(record)
          groupKey = Object.keys(result)[0]
          value = result[groupKey]
        } else {
          // Use user_identifier to select grouping key
          if (user_identifier === 'user_email') {
            groupKey = record.userEmail
          } else {
            groupKey = record.userId
          }
          value = record['eventData'][groupedValKey]
          if (stat === 'average') {
            value = value / data.length
          } else if (stat === 'count') {
            value = 1
          }
        }
        if (!groupedData[groupKey]) {
          groupedData[groupKey] = value
        } else {
          groupedData[groupKey] += value
        }
      })
      const mappedData = Object.keys(groupedData).map((key) => {
        if (stat !== 'count') {
          // For non-count stats, convert ms to minutes, rounded
          let minutes = Math.round(groupedData[key] / 60000)
          return { [xFieldLabel]: key, minutes: minutes === 0 ? 0.1 : minutes }
        }
        return {
          [xFieldLabel]: key,
          [yFieldLabel]: groupedData[key] === 0 ? 0.1 : groupedData[key],
        }
      })
      setGroupedData(mappedData)
    } else {
      setGroupedData([])
    }
  }, [data, user_identifier, groupingFunc])

  if (!handleBarClick) {
    handleBarClick = (data) => {
      if (setShowDetailsOn && detailKey) {
        setShowDetailsOn(detailKey)
      }
    }
  }
  return (
    <BarGraph
      data={groupedData}
      xField={xFieldLabel}
      yField={yFieldLabel}
      tooltipFunc={tooltipFunc}
      onBarClick={handleBarClick}
    />
  )
}

export default GroupedByUserGraph
